<template>
  <div class="flex items-center gap-x-2.5">
    <input
      :id="id"
      v-model="model"
      type="checkbox"
      :value="props.value"
      class="checked:bg-[url('/images/checkmarkThick.svg')] checked:bg-action checked:bg-[length:75%_75%] checked:bg-center checked:border-action checked:bg-no-repeat appearance-none h-5 w-5 border-2 border-solid rounded border-gray-dark focus:outline-none focus:ring-2 focus:ring-offset-2"
    />
    <label :for="id">{{ props.label }}</label>
  </div>
</template>
<script setup lang="ts">
const model = defineModel<boolean>('checked')

const props = defineProps<{
  value?: string
  label: string
}>()

const id = useId()
</script>
